<template>
  
  <PCHeaderBar v-if="!useIsMobile().value" />
  <div class="search-bar" v-else>
    <HomeSearch :isPreview="true" />
  </div>

  <div class="error-div">
    <img v-lazy="$cvWebpFn(`https://img.kilimall.com/c/h5/error_404.png`, { w: useIsMobile().value ? 360 : 560 })" class="err-img" />
    <div class="tips" :data-mode="useIsMobile().value ? 'wap' : 'pc'">{{ errorMsg }}</div>

    <div class="youmaylike" v-if="useIsMobile().value">
      <p class="youmaylike-title">You may also like</p>
      <KRecommendProduct :recommendId="1" />
    </div>
    <div class="pc-youmaylike" v-else>
      <PCYouMayLike :recommendId="1"  />
    </div>
    <!-- <a class="to-home-btn" href="/">
      Go to homepage
    </a> -->
  </div>
  
  <LazyPCFooter v-if="!useIsMobile().value" />
  <KTabbar v-else />
</template>

<script setup>

useHead({
  meta: [
    { name: 'robots', content: 'noindex, nofollow' },
    { name: 'X-Robots-Tag', content: 'noindex, nofollow' }
  ]
})

const route = useRoute()
if(route.query.development === '1') {
  console.log('调试模式 error.vue: ', useError().value)
  console.log('调试模式 error.vue: ', JSON.stringify(route))
}

const errorMsg = useError().value.message || 'The page you are trying to access is not available.'
</script>

<style scoped lang="scss">
.search-bar::v-deep(.search-div) {
  background-color: #f5f5f5 !important;
}
.youmaylike{
  padding: 10px;
  .youmaylike-title{
    font-weight: 600;
    font-size: 28px;
    margin: 60px 0 10px 0;
    text-align: left;
  }
}
.pc-youmaylike{
  width: var(--viewport-width);
  margin: 160px auto 60px auto;
}
.error-div {
  text-align: center;
  padding: 10vh 0;
  background-color: #f5f5f5;
  @media screen and (max-width: 360px){
    .err-img{
      width: 80%;
      min-height: 600px;
    }
  }
  @media screen and (min-width: 750px) {
    .err-img{
      height: 560px;
    }
  }
  .tips{
    margin-top: 60px;
    font-size: 26px;
  }
  .tips[data-mode="pc"] { font-size: 28px;}
  .to-home-btn{
    cursor: pointer;
    width: 400px;
    height: 80px;
    line-height: 80px;
    color: #fff;
    display: inline-block;
    margin-top: 60px;
    background-color: var(--default_color);
    border-radius: 60px;
  }
}
</style>
